import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ConsultProtocolsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useConsultProtocols} from './hooks';

const {title} = translations['pt-br'].privateFlow.consultProtocols;

export function ConsultProtocolsWrapper() {
	const {handleBack} = useConsultProtocols();

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				dataTagId={{
					backButton: ConsultProtocolsTaggingEnum.CLICK_VOLTAR_CONSULTA_PROTOCOLOS,
				}}
				title={title}
				handleBack={handleBack}
				variant={'subRoute'}
				hideClose
			/>
		</PageWrapperLayout>
	);
}
